// extracted by mini-css-extract-plugin
export default {"container":"Vp-z","heading":"Wp-z","text":"Xp-z","info":"Yp-z","link":"Zp-z","fullMaxWidth":"_p-z"};